import { flushSync } from "react-dom";

interface ViewTransitionLike {
  ready?: Promise<unknown>;
  finished?: Promise<unknown>;
}

type TransitionDocument = Document & {
  startViewTransition?: (callback: () => void) => ViewTransitionLike;
};

export function itemTransitionName(itemId: string): string {
  return `bedrock-item-${itemId.replace(/[^a-zA-Z0-9_-]/g, "-")}`;
}

export function runViewTransition(update: () => void, sharedItemId?: string, direction: "in" | "out" = "in"): void {
  const motionReduced = typeof matchMedia !== "undefined" && matchMedia("(prefers-reduced-motion: reduce)").matches;
  const transitionDocument = document as TransitionDocument;
  if (motionReduced || typeof transitionDocument.startViewTransition !== "function") {
    update();
    return;
  }

  const source = sharedItemId
    ? [...document.querySelectorAll<HTMLElement>("[data-canvas-item-id]")].find((element) => element.dataset["canvasItemId"] === sharedItemId)
    : undefined;
  const transitionName = sharedItemId ? itemTransitionName(sharedItemId) : undefined;
  if (sharedItemId) document.documentElement.classList.add("bedrock-item-transition");
  if (source && transitionName && direction === "in") source.style.viewTransitionName = transitionName;

  const cleanup = () => {
    if (source) source.style.viewTransitionName = "";
    document.documentElement.classList.remove("bedrock-item-transition");
  };
  let updated = false;

  try {
    const transition = transitionDocument.startViewTransition(() => {
      if (source && direction === "in") source.style.viewTransitionName = "";
      flushSync(() => {
        update();
        updated = true;
      });
      if (source && transitionName && direction === "out") source.style.viewTransitionName = transitionName;
    });
    void transition.ready?.catch(cleanup);
    if (transition.finished !== undefined) void transition.finished.then(cleanup, cleanup);
    else cleanup();
  } catch {
    cleanup();
    if (!updated) update();
  }
}
